module.exports.ca = function ca() {
  var ca = window.ca;

  if (ca) {
    ca.apply(null, arguments);
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@cian/analytics/lib/index.js
// module id = 78
// module chunks = 0